import { Theme } from '@mui/material';

export const sxStyles = {
  mobileBreadcrumbs: (theme: Theme) => ({
    svg: {
      marginRight: '0.5rem',
      fill: theme.palette.text.secondary,
    },
  }),
  breadcrumbs: (theme: Theme) => ({
    width: '80%',
    svg: {
      fill: theme.palette.text.secondary,
    },
  }),
};
